var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{staticClass:"actionbar",class:{ shadow: !_setup.isBottom },style:({
      paddingBottom: `calc(env(safe-area-inset-bottom) + ${_setup.paddingBottom}px)`
    }),attrs:{"id":"actionbar"}},[_vm._t("default")],2),_c('div',{staticClass:"placeholder",style:(`min-height: ${_setup.minHeight}px; height: ${_setup.height}px`)})])
}
var staticRenderFns = []

export { render, staticRenderFns }